(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["empyreum-offer-popup"] && !Shopify.designMode) return;
  try {
    
/* Once per browser origin and campaign. No visitor IDs, cookies or tracking. */
if (!customElements.get('emp-offer-popup')) {
  class EmpOfferPopup extends HTMLElement {
    connectedCallback() { this.boot = setTimeout(() => this.init(), 0); }
    init() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.controller = new AbortController();
      this.editor = this.dataset.editor === 'true';
      this.key = 'empyreum:offer:seen:v1:' + (this.dataset.campaign || 'konyvkosar-2026');
      this.token = String(Date.now()) + ':' + Math.random().toString(36).slice(2);
      this.finished = false;
      const on = (node, type, fn) => node.addEventListener(type, fn, {signal: this.controller.signal});
      on(this.dialog, 'click', event => {
        if (event.target.closest('[data-emp-offer-close],[data-emp-offer-cta]')) this.dismiss();
        if (event.target === this.dialog && this.backdropDown) {
          const r = this.dialog.getBoundingClientRect();
          if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.dismiss();
        }
        this.backdropDown = false;
      });
      on(this.dialog, 'pointerdown', event => { this.backdropDown = event.target === this.dialog; });
      on(this.dialog, 'cancel', event => { event.preventDefault(); this.dismiss(); });
      on(this.dialog, 'close', () => this.unlock());
      on(window, 'pagehide', () => this.dismiss());
      if (this.editor) {
        const select = event => { if (String(event.detail.sectionId) === this.dataset.sectionId) this.open(); };
        on(document, 'shopify:section:select', select);
        on(document, 'shopify:block:select', select);
        on(document, 'shopify:section:deselect', event => { if (String(event.detail.sectionId) === this.dataset.sectionId) this.dismiss(); });
        if (this.dataset.editorPreview === 'true') this.timer = setTimeout(() => this.open(), 180);
        return;
      }
      if (this.dataset.enabled !== 'true') return;
      // If durable storage is unavailable, do not keep interrupting the buyer.
      try {
        const probe = this.key + ':probe:' + this.token;
        localStorage.setItem(probe, '1'); localStorage.removeItem(probe);
      } catch (_) { this.finished = true; return; }
      on(window, 'storage', event => {
        if (event.key === this.key && event.newValue) {
          this.finished = true; clearTimeout(this.timer);
          if (this.dialog.open && event.newValue !== this.token) this.dismiss();
        }
      });
      on(document, 'visibilitychange', () => { if (!document.hidden && !this.finished) this.plan(300); });
      this.plan(Math.max(0, Number(this.dataset.delay) || 0) * 1000);
    }
    seen() {
      try { return !!localStorage.getItem(this.key); }
      catch (_) { this.finished = true; return true; }
    }
    busy() {
      if (document.hidden) return true;
      if (document.activeElement && document.activeElement.matches('input,textarea,select,[contenteditable="true"]')) return true;
      const others = document.querySelectorAll('dialog[open],modal-dialog[open],.side-panel.active,.side-panel.open,.shopify-pc__banner__dialog,.shopify-pc__prefs__dialog');
      return Array.from(others).some(node => node !== this.dialog && node.getClientRects().length && getComputedStyle(node).visibility !== 'hidden');
    }
    plan(delay) {
      clearTimeout(this.timer);
      if (this.finished || !this.isConnected) return;
      this.timer = setTimeout(() => this.claim(), delay);
    }
    async claim() {
      if (this.finished || !this.isConnected || this.seen()) { this.finished = true; return; }
      if (this.busy()) { this.plan(1000); return; }
      if (navigator.locks && navigator.locks.request) {
        try {
          await navigator.locks.request(this.key, {ifAvailable: true}, lock => {
            if (lock) this.attempt(); else this.plan(500);
          });
          return;
        } catch (_) { /* Older/restricted browsers use a short shared lease. */ }
      }
      const leaseKey = this.key + ':lease';
      let owned = false;
      try {
        let current;
        try { current = JSON.parse(localStorage.getItem(leaseKey) || 'null'); } catch (_) { current = null; }
        if (current && current.until > Date.now()) { this.plan(1000); return; }
        localStorage.setItem(leaseKey, JSON.stringify({token: this.token, until: Date.now() + 2000}));
        await new Promise(resolve => setTimeout(resolve, 150));
        const lease = JSON.parse(localStorage.getItem(leaseKey) || 'null');
        owned = !!lease && lease.token === this.token;
        if (owned) this.attempt(); else this.plan(1000);
      } catch (_) { this.finished = true; }
      finally {
        try { if (owned && JSON.parse(localStorage.getItem(leaseKey) || 'null')?.token === this.token) localStorage.removeItem(leaseKey); } catch (_) { /* No storage: stop safely. */ }
      }
    }
    attempt() {
      if (!this.isConnected || this.finished || this.seen()) { this.finished = true; return; }
      if (this.busy()) { this.plan(1000); return; }
      if (!this.open()) return;
      // Mark at first actual display, so even a reload cannot show it twice.
      try { localStorage.setItem(this.key, this.token); }
      catch (_) { this.dismiss(); }
      this.finished = true;
    }
    open() {
      if (!this.isConnected || !this.dialog || this.dialog.open) return false;
      try {
        this.dialog.showModal();
        document.documentElement.classList.add('emp-offer-lock');
        this.querySelector('.emp-offer__close')?.focus({preventScroll: true});
        return true;
      } catch (_) { return false; }
    }
    dismiss() { clearTimeout(this.timer); if (this.dialog?.open) this.dialog.close(); this.unlock(); }
    unlock() { if (!document.querySelector('dialog.emp-offer[open]')) document.documentElement.classList.remove('emp-offer-lock'); }
    disconnectedCallback() { clearTimeout(this.boot); this.dismiss(); this.controller?.abort(); }
  }
  customElements.define('emp-offer-popup', EmpOfferPopup);
}

  } catch(e) { console.error(e); }
})();
})();
